import React, { useEffect, useState } from "react";
import { Col, Container, Nav, Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import ReactFlagsSelect from "react-flags-select";
import { toast } from "react-toastify";
import Constants from "../Variables/Constants";
import axios from "axios";

function FooterComponent() {
  const [select, setSelect] = useState("GB");
  const [categoryList, setCategoryList] = useState([]);

  const getCategoryDetail = async () => {
    try {
      const resp = await axios.get(`${Constants.getUrls.getAllCategory}`);
      if (resp.data.status === "success") {
        setCategoryList(resp?.data?.data.docs); 
      } else {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(resp.data.message);
      }
    } catch (error) {
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  useEffect(() => {
    getCategoryDetail();
  }, []);

  return (
    <>
      <div className="text-center contactHighlight fs-16 sbFooter z-2 pt-4 d-flex gap-1 align-items-center justify-content-center">
        <p>
          <b>TO PLACE AN ORDER, CONTACT OUR CREATIVE TEAM AT BEST</b>
        </p>
        <p className="fw-bold ms-1">CALL NOW: 718.633.8737</p>
      </div>
      <footer className="z-1">
        <Container>
          <Row className="flex-wrap">
            <Col sm="2">
              <NavLink
                to="/"
                className="navbar-brand d-flex justify-content-center"
              >
                <img loading="lazy"  src={logo} />
              </NavLink>
            </Col>
            <Col sm="9">
              <Row className="g-1">
                {categoryList.length > 0 && (
                  <>
                    <Col>
                      <div className="footer_menu">
                        <h5>Main Products</h5>
                        <ul>
                          {categoryList.length >= 4 ? (
                            <>
                              {categoryList.slice(0, 5).map((item, index) => (
                                <li key={item._id}>
                                  <NavLink to={`/category?catid=${item._id}`}>
                                    {item.title}
                                  </NavLink>
                                </li>
                              ))}
                            </>
                          ) : (
                            <>
                              <li>
                                <NavLink to="">Ark Curtains</NavLink>
                              </li>
                              <li>
                                <NavLink to="">Torah Mantels</NavLink>
                              </li>
                              <li>
                                <NavLink to="">Silver Ornaments</NavLink>
                              </li>
                              <li>
                                <NavLink to="">Bimah</NavLink>
                              </li>
                              <li>
                                <NavLink to="">Bein Gavra</NavLink>
                              </li>
                            </>
                          )}
                        </ul>
                      </div>
                    </Col>

                    <Col>
                      <div className="footer_menu">
                        <h5>Other Products</h5>
                        <ul>
                          {categoryList.length >= 9 ? (
                            <>
                              {categoryList.slice(5, 10).map((item, index) => (
                                <li key={item._id}>
                                  <NavLink to={`/category?catid=${item._id}`}>
                                    {item.title}
                                  </NavLink>
                                </li>
                              ))}
                            </>
                          ) : (
                            <>
                              <li>
                                <NavLink to="">Tallis/Tefillin Bags</NavLink>
                              </li>
                              <li>
                                <NavLink to="">Passover</NavLink>
                              </li>
                              <li>
                                <NavLink to="">Challah Cover</NavLink>
                              </li>
                              <li>
                                <NavLink to="">Synagoge Essentials</NavLink>
                              </li>
                              <li>
                                <NavLink to="">Batel</NavLink>
                              </li>
                            </>
                          )}
                        </ul>
                      </div>
                    </Col>
                  </>
                )}
                <Col>
                  <div className="footer_menu">
                    <h5>Company</h5>
                    <ul>
                      <li>
                        <NavLink to="/about">About Us</NavLink>
                      </li>
                      <li>
                        <NavLink to="terms">Terms & Services</NavLink>
                      </li>
                      <li>
                        <NavLink to="Privacy">Privacy Policies</NavLink>
                      </li>{" "}
                      <li>
                        <NavLink to="return">Return Policies</NavLink>
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col>
                  <div className="footer_contact footer_menu">
                    <h5 className="ms-3">Address</h5>

                    <ul>
                      <li className="d-flex flex-column ">
                        <NavLink className={"ms-5"} to="">
                          Best Embroidery
                        </NavLink>
                        <div className="d-flex">
                          <i className="me-2 text-white bi bi-geo-alt-fill"></i>
                          <NavLink to="" className={"ms-1"}>
                            {" "}
                            3915 14th ave Brooklyn ny 11218
                          </NavLink>
                        </div>
                      </li>
                      <li>
                        <i className="me-2 text-white bi bi-telephone-fill"></i>
                        <NavLink className={"ms-1"} to="">
                          718.633.8737
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col>
                  <div className="social_media">
                    <ul>
                      <li className=" d-flex flex-column gap-1">
                        {/* Language Selector */}
                        <h1 className="fs-20 fw-500 text-white">Language</h1>
                        <ReactFlagsSelect
                          selected={select}
                          className="pb-0 bg-white border-none w-75 mb-5 rounded-4"
                          countries={["US", "GB", "FR", "DE", "IT"]}
                          customLabels={{
                            US: "EN",
                            GB: "GB",
                            FR: "FR",
                            DE: "DE",
                            IT: "IT",
                          }}
                          placeholder="Select Language"
                          onSelect={(code) => setSelect(code)}
                        />
                      </li>
                      <h1 className="fs-20 fw-500 text-white mt-4">
                        Socal Media
                      </h1>
                      <li className="d-flex  gap-3">
                        <div>
                          <NavLink className="">
                            <i className="bi fs-24 text-white bi-instagram"></i>
                          </NavLink>
                        </div>
                        <div>
                          <NavLink className="">
                            <i className="bi fs-24 text-white bi-facebook"></i>
                          </NavLink>
                        </div>
                        <div>
                          <NavLink className="">
                            <i className="bi fs-24 text-white bi-twitter-x"></i>
                          </NavLink>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <hr />
        </Container>
        <div className="copyright">
          <p>@Copyright Bestembroidery {new Date().getFullYear()}</p>
        </div>
      </footer>
    </>
  );
}

export default FooterComponent;
